export const DOT_SYMBOL = String.fromCharCode(8226);
export const EURO_SYMBOL = String.fromCharCode(8364);
export const DOLLAR_SYMBOL = String.fromCharCode(36);
export const NON_BREAKING_SPACE = String.fromCharCode(160);

export const SOCIAL_MEDIA_SHARE_LINKS = {
  FACEBOOK: 'https://www.facebook.com/sharer/sharer.php?u=',
  PINTEREST: 'https://pinterest.com/pin/create/button/?url=',
  TWITTER: 'https://twitter.com/intent/tweet?url=',
  LINKEDIN: 'https://www.linkedin.com/sharing/share-offsite/?url=',
};

export const PRODUCTS_RECOMMENDATION_CAROUSEL_SLIDES_AMOUNT = 12;
export const PRODUCT_CARDS_CAROUSEL_SLIDES_AMOUNT = 15;

export const DESKTOP_WIDTH = 1024;
export const MOBILE_WIDTH = 768;

export const HEADER_HEIGHT = 168;
export const AVIS_VERIFIES_URL_REVIEWS = 'https://awsapis3.netreviews.eu/product';
export const SCHEMA = 'https://schema.org';
export const SCHEMA_PRODUCT = 'https://schema.org/Product';
export const SCHEMA_OFFER = 'https://schema.org/Offer';
export const SCHEMA_PRODUCT_IN_STOCK = 'https://schema.org/InStock';
export const SCHEMA_PRODUCT_OOS = 'https://schema.org/OutOfStock';
export const SCHEMA_REVIEW = 'https://schema.org/Review';
export const SCHEMA_PERSON = 'https://schema.org/Person';
export const SCHEMA_RATING = 'https://schema.org/Rating';
export const SCHEMA_FAQ = 'https://schema.org/FAQPage';
export const SCHEMA_QUESTION = 'https://schema.org/Question';
export const SCHEMA_ANSWER = 'https://schema.org/Answer';
export const NUMBER_OF_REVIEWS = 5;
export const NUMBER_OF_ITEMS_FOR_SEO = 1000;
export const SCHEMA_AGGREGATE_RATING = 'https://schema.org/AggregateRating';
export const URL_FOR_TRACKING_SHIPING = 'https://aroma-zone.shipup.co/?orderNumber=';
export const GRAPHQL_REQUEST_LIMIT_FOR_SKINCARE_AVOID_GRAPHQL_ERROR = 150;
export const VISIBLE_IN_PRODUCTION = true;
export const CUSTOMIZER_BANNER_URL =
  '//images.ctfassets.net/0xsz2r7o7t3z/62LMKr2XO84SWY5LNsTMjJ/8bc117fb8cc7b9d4b6b9af800cfb9287/Customization_generic_image_2500px1566px.jpg';
export const HOME_OOS_TOAST_DELAY = 15000;

export const EXCLUDED_MIDDLEWARE_ROUTES = ['/adyen-redirect-back'];

export const VSF_SSO_COOKIE = 'vsf-commercetools-token';
export const PAGE_PARAM_NAME = 'page';

export const REFERRAL_VALUE = 500;
